/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfUserInfo } from '../../models/platform-api-result-of-user-info';
import { PlatformOleAppOpenen } from '../../models/platform-ole-app-openen';

export interface PostUserpresenceActionOleappopenen$Params {
      body: PlatformOleAppOpenen
}

export function postUserpresenceActionOleappopenen(http: HttpClient, rootUrl: string, params: PostUserpresenceActionOleappopenen$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserInfo>> {
  const rb = new RequestBuilder(rootUrl, postUserpresenceActionOleappopenen.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserInfo>;
    })
  );
}

postUserpresenceActionOleappopenen.PATH = '/api/userpresence/action/oleappopenen';
